import React from "react";
import { Box, Button } from "@mui/material";
import { ImageUp, Trash2 } from "lucide-react";
import { makeStyles } from "@mui/styles";
import { CircularLoader } from "../../loading/CircularLoader";

const useStyles = makeStyles((theme) => ({
  uploadButton: {
    display: "flex",
    gap: theme.spacing(1),
    maxWidth: theme.breakpoints.values.sm,
  },
  deleteButton: {
    width: "fit-content",
  },
}));

interface ImageUploadButtonsProps {
  onUpload: () => void;
  onDelete: () => void;
  uploadLabel: string;
  loading: boolean;
  fileName: string | null;
}

export const ImageUploadButtons: React.FC<ImageUploadButtonsProps> = ({
  fileName,
  onUpload,
  onDelete,
  uploadLabel,
  loading,
}) => {
  const s = useStyles();
  return (
    <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
      <Button
        variant="outlined"
        className={s.uploadButton}
        size="large"
        fullWidth
        onClick={fileName ? onDelete : onUpload}
      >
        {loading ? (
          <CircularLoader sx={{ margin: 0.7 }} color="primary" />
        ) : fileName ? (
          <>
            {fileName} <Trash2 size={20} />
          </>
        ) : (
          <>
            Upload {uploadLabel} <ImageUp size={20} />
          </>
        )}
      </Button>
    </Box>
  );
};
